module.exports = __webpack_public_path__ + "static/img/selection_2.9014c8c5.png";